import { render, staticRenderFns } from "./shiftPanel.vue?vue&type=template&id=c13b7ed2&scoped=true"
import script from "./shiftPanel.vue?vue&type=script&lang=js"
export * from "./shiftPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b7ed2",
  null
  
)

export default component.exports